// Połączenie WebSocket z bramą gry: msgpack, token w podprotokole, automatyczne wznawianie.
import { decode, encode } from '@msgpack/msgpack';

import { WS_BASE } from '../config.js';
import { C, PROTOCOL_VERSION, type ServerMessage } from './protocol.js';
import { freshAccessToken } from './api.js';

type Handler = (msg: ServerMessage) => void;

export class GameSocket {
  private ws: WebSocket | null = null;
  private retry = 0;
  private closedByUser = false;
  private pingTimer = 0;
  rtt = 0;
  onMessage: Handler = () => {};
  onStatus: (s: 'connecting' | 'online' | 'offline') => void = () => {};

  constructor(private characterId: number) {}

  async connect(): Promise<void> {
    this.closedByUser = false;
    this.onStatus('connecting');
    const token = await freshAccessToken();
    if (!token) { this.onStatus('offline'); return; }
    const ws = new WebSocket(`${WS_BASE}/ws/game/`, ['deadlodz', token]);
    ws.binaryType = 'arraybuffer';
    ws.onopen = () => {
      this.retry = 0;
      this.onStatus('online');
      this.send({ t: C.HELLO, v: PROTOCOL_VERSION, char: this.characterId });
      this.pingTimer = window.setInterval(() => this.send({ t: C.PING, ts: performance.now() }), 5000);
    };
    ws.onmessage = (e) => {
      const msg = decode(new Uint8Array(e.data as ArrayBuffer)) as ServerMessage;
      if (msg.t === 'po') this.rtt = performance.now() - (msg as { ts: number }).ts;
      this.onMessage(msg);
    };
    ws.onclose = (e) => {
      clearInterval(this.pingTimer);
      this.ws = null;
      this.onStatus('offline');
      if (this.closedByUser || e.code === 4401 || e.code === 4409) return;
      const delay = Math.min(15000, 500 * 2 ** this.retry++) + Math.random() * 300;
      setTimeout(() => this.connect(), delay);
    };
    this.ws = ws;
  }

  send(msg: Record<string, unknown>): void {
    if (this.ws?.readyState === WebSocket.OPEN) this.ws.send(encode(msg) as Uint8Array<ArrayBuffer>);
  }

  close(): void {
    this.closedByUser = true;
    this.ws?.close(1000);
  }

  get online(): boolean {
    return this.ws?.readyState === WebSocket.OPEN;
  }
}
